import React, { Component } from 'react';

import LowerHeader from '../../components/Header/LowerHeader/LowerHeader';
import Toolbar from '../../components/Header/Toolbar/Toolbar';
import { Button, Badge } from 'react-bootstrap';
import Api from '../../api/api';
import './CacheCleanContainer.css';

const keyList = ['Dealer', 'Vehicle', 'Booking'];

class FeaturesContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      authToken: localStorage.getItem('authToken'),
      loading: false,
      error: '',
      success: '',
      target: '',
    };
  }

  componentDidMount() {
    const { authToken } = this.state;
    if (!authToken) {
      this.props.history.push({
        pathname: '/sessionexpired',
        state: {
          error: 'Unauthorised or Session Expired',
          error_description: 'Please try to login again',
        },
      });
    } else {
      const obj = document.getElementById('navLoginLogout');
      obj.innerText = 'Logout';
    }
  }

  handleClick = async type => {
    this.setState({ success: '', target: '', loading: true });
    try {
      await Api.cleanCache(type);
      this.setState({ success: 'success', target: type });
    } catch (error) {
      this.setState({ error: 'error' });
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  render() {
    const { success, error } = this.state;
    return (
      <React.Fragment>
        <div className="container-header">
          <Toolbar />
        </div>

        <div className="container-fluid text-center">
          <LowerHeader pageTitle="Clean Cache" />
        </div>
        <div className="container-fluid">
          {keyList.map(item => {
            return (
              <Button
                onClick={() => this.handleClick(`${item}*`)}
                className="clean-cache_button"
                disabled={this.state.loading}
              >
                Clean {item} Cache
              </Button>
            );
          })}
          {error && (
            <h2>
              <Badge variant="danger">Something went wrong and operation failed</Badge>
            </h2>
          )}
          {success && (
            <h2>
              <Badge variant="success">{this.state.target} Cache cleaned</Badge>
            </h2>
          )}
        </div>
      </React.Fragment>
    );
  }
}

export default FeaturesContainer;



// WEBPACK FOOTER //
// ./src/containers/CacheClean/CacheCleanContainer.js